
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shipper/shipperguide/demo",
      function () {
        return require("private-next-pages/shipper/shipperguide/demo.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shipper/shipperguide/demo"])
      });
    }
  